import { render, staticRenderFns } from "./SharerRateCard.vue?vue&type=template&id=1a59a7a2&scoped=true"
import script from "./SharerRateCard.vue?vue&type=script&lang=js"
export * from "./SharerRateCard.vue?vue&type=script&lang=js"
import style0 from "./SharerRateCard.vue?vue&type=style&index=0&id=1a59a7a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a59a7a2",
  null
  
)

export default component.exports